import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { ClientWorkOrderDetails } from '../types';
import { PostOffice } from '@/common';

type Body = Partial<{
  title: string;
  address: string;
  postOffice: PostOffice;
  employees: number;
  comment: string;
}>;

export const updateWorkOrderProposal = async ({
  id,
  data,
}: {
  id: string;
  data: Body;
}): Promise<ClientWorkOrderDetails> => {
  console.log(data);
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/client-work-order-proposals/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as ClientWorkOrderDetails;
  return response;
};
